module.exports = __webpack_public_path__ + "img/ok.2ce4893d.png";